export class DeletedCustomFieldError extends Error {
  constructor(message = 'Custom field has been deleted from account settings') {
    super(message);
    this.name = 'DeletedCustomFieldError';
    Object.setPrototypeOf(this, DeletedCustomFieldError.prototype);
  }
}
